<template>
	<div class="el-tag user-tag" :title="user.name">
		<ion-icon class="user-tag__icon" name="contact"></ion-icon>
		<p class="user-tag__name">{{ user.name }}</p>
	</div>
</template>

<script>
	
	export default {
		
		props: [ "user" ]
		
	}
	
</script>

<style lang="scss" scoped>
	
	$height: 20px;
	
	.user-tag {
		padding: 0 !important;
		height: $height;
	}
	
	.user-tag__icon {
		width: $height - 4px;
		height: $height - 4px;
		padding: 0;
		margin: 0;
		top: 2px;
		right: 0;
		bottom: 0;
		left: 2px;
		float: left;
	}
	
	.user-tag__name {
		line-height: $height - 2px;
		height: $height -2px;
		margin: 0;
		float: left;
    	padding: 0 6px 0 4px;
		font-weight: 600;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Users/Tag.vue